import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

export module ioValidators {

    class ListValidatorClass {
        private List: any[] = [];
        private CheckField: string = null;
        Validator = (control: AbstractControl): { isInvalid: boolean } => {
            let _isValid = true;
            if (control.value) {
                if (this.CheckField) {
                    _isValid = this.List.findIndex(l => l[this.CheckField] === control.value) > -1;
                } else {
                    _isValid = this.List.findIndex(l => JSON.stringify(l) === JSON.stringify(control.value)) > -1;
                }
            }
            return _isValid ? null : { isInvalid: !_isValid };
        }

        constructor (_list, _checkField?) {
            this.List = _list;
            this.CheckField = _checkField;
        }
    }
    export function ListValidator<T>(_List: T[], _checkField?: string) {
        return new ListValidatorClass(_List, _checkField);
    }

    class _CustomValidatorClass {
        private _validatorFn: (_value: ValidationErrors, _parent: FormGroup | FormArray, _self: AbstractControl) => ValidationErrors | Observable<ValidationErrors>;

        Validator = (control: AbstractControl): ValidationErrors | Observable<ValidationErrors> => {
            return control.parent ? this._validatorFn(control.value, control.parent, control) : null;
        }

        constructor (_fn: (_value: ValidationErrors) => ValidationErrors | Observable<ValidationErrors>) {
            this._validatorFn = _fn;
        }
    }

    export function CustomFunctionValidator(_fn: (_value: any, _parent?: FormGroup | FormArray, _self?: AbstractControl) => ValidationErrors | Observable<ValidationErrors>) {
        return new _CustomValidatorClass(_fn).Validator;
    }



    export function isEmail(_control: AbstractControl) {
        // tslint:disable-next-line:max-line-length
        const regEx: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let valid = false;
        if (regEx.test(_control.value) || _control.value === '') {
            valid = true;
        }
        return valid ? null : { isEmail: true };
    }

    export function isWeakPassword(control: AbstractControl) {
        const password = control.value;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumbers = /\d/.test(password);
        const hasNonalphas = /\W|_/.test(password);
        if ((password.length < 8) || Number(hasUpperCase) + Number(hasLowerCase) + Number(hasNumbers) + Number(hasNonalphas) < 3) {
            return { weakPassword: true };
        } else {
            return null;
        }
    }

    export function hasPasswordComplexity(control: AbstractControl) {

        // Min. length 8 char and at least 1 uppercase, 1 number, 3 lowercase and 1 special char (&@#$!)

        const password = control.value;
        const hasComplexity = /^(?=.*[A-Z])(?=.*[&@#$!])(?=.*[0-9])(?=.*[a-z].*[a-z].*[a-z]).{8,}$/.test(password);
        console.log(hasComplexity)

        // if (hasPasswordComplexity) {
        //     return ({ hasPasswordComplexity: true });
        // } else {
        //     return (null);
        // }


        return  hasComplexity ?  null : { NoPasswordComplexity: true };
     
    }

    export function PasswordMatcher(group: FormGroup) {
        const pass1 = group.controls['Password'];
        const pass2 = group.controls['PasswordRetype'];
        if (pass1.value !== pass2.value) {
            return ({ passwordsMismatch: true });
        } else {
            return (null);
        }
    }

    export function asyncemailMatcher(control: AbstractControl): Promise<{ [key: string]: boolean }> {
        const Username = control.get('Username');
        const Password = control.get('Password');

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (!Username || !Password) { return null; }
                resolve(Username.value === Password.value ? null : { invalidCredentials: true });
            }, 1000);
        });

    };

    export function isCyMobile(control: AbstractControl) {
        // val = control.value.replace(' ','').replace('-','').replace('.','').trim;  //.replaceAll(/ |-|./gi, '');
        // var regEx = /^(((9)|(3579))[0-9]{7}|[]{0})$/; //if (starts with 3579 or 9) and has 7 more chars or if is empty
        const regEx = /^((003579)[0-9]{7}|[]{0})$/; // if starts with 003579 and has 7 more chars
        const valid = regEx.test(control.value);
        return valid ? null : { isCyMobile: true };
    }

    export function isMACAddress(control: AbstractControl) {
        const regEx = /^[a-fA-F0-9:]{17}|[a-fA-F0-9]{12}$/;
        const valid = regEx.test(control.value);
        return valid ? null : { isMACAddress: true };
    }

    export function emailOrMobileRequired(group: FormGroup) {
        const email = group.controls['Email'];
        const Mobile = group.controls['Mobile'];
        if (!email.value && !Mobile.value) {
            return ({ emailOrMobileRequired: true });
        } else {
            return (null);
        }
    }

    export function cannotContainSpaces(control: AbstractControl) {
        if (control.value.indexOf(' ') >= 0) {
            return { cannotContainSpaces: true };
        } else {
            return null;
        }
    }

    export function shouldBeUnique(control: AbstractControl) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (control.value === 'CSP') {
                    resolve({ shouldBeUnique: true });
                } else {
                    resolve(null);
                }
            }, 2000);
        });
    }

    export function validForm(_form: FormGroup) {
        _form.updateValueAndValidity();
        Object.keys(_form.controls).forEach(key => {
            _form.get(key).markAsTouched();
            _form.get(key).updateValueAndValidity();
        });
        return _form.valid;
    };


    //Get FormGroup and Return Controls with Error ( Invalid )
    export function getFormValidationErrors(_form: FormGroup) {
        let _FormControlErrors: any[] = [];

        Object.keys(_form.controls).forEach(key => {
            const controlErrors: ValidationErrors = _form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    _FormControlErrors.push({ 'control': key, 'error': keyError })
                    // console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                });
            }
        });
        return _FormControlErrors;
    };


    // Validate Date < Current Datetime
    export function DateValidation(control: AbstractControl) {

        let ValidationResult = null

        const _CurrentDate = new Date();
        let _InpuDate: Date;

        // const _last3days = new Date();
        // _last3days.setDate(_CurrentDate.getDate() - 3);

        try {

            if (control.value) {
                _InpuDate = new Date(control.value.toString())

                if (_InpuDate.getTime() >= _CurrentDate.getTime()) {
                    ValidationResult = { invalidDate: true };
                }
            }

            //  else if (_InpuDate.getTime() <= _last3days.getTime()) {
            //     ValidationResult = { invalidDate: true }
            // }

        } catch (error) {
            ValidationResult = { invalidDate: true }
        }

        return ValidationResult;

    }

    // Validate Date < Current Datetime
    export function TimeValidation(control: AbstractControl) {

        let ValidationResult = null

        try {
            // regular expression to match required time format
            let re = /^\d{1,2}:\d{2}([ap]m)?$/;

            if (control.value.toString() != '' && !control.value.toString().match(re)) {
                //console.log("Invalid time format: " + control.value.toString());
                ValidationResult = { invalidTime: true };
            }

        } catch (error) {
            ValidationResult = { invalidTime: true }
        }


        return ValidationResult;

    }

    // Number Validations
    export module Numbers {

        export function isZero(control: AbstractControl) {
            if (isNaN(control.value)) { return ({ isInvalid: true }) }

            return control.value === 0 ? { isZero: true } : null;
        }

        export function isCurrency(control: AbstractControl) {

            if (isNaN(control.value)) { return ({ isInvalid: true }) }

            const regEx = /^[-]{0,1}[0-9]+(\.[0-9]{1,4})?$/;
            const valid = regEx.test(control.value);
            return valid ? null : { IsNotCurrency: true };
        }

        export function isNegative(control: AbstractControl) {
            if (isNaN(control.value)) { return ({ isInvalid: true }) }

            return control.value < 0 ? { isNegative: true } : null;
        }


    }


    export class WhiteSpaceValidator {
        static noWhiteSpace(control: AbstractControl) : ValidationErrors | null {
            if  ( control.value && control.value.toString().indexOf(' ') === 0){
                return {noWhiteSpace: true}
            }
            return null;
        }
    }



}








